import {
  USER_START,
  USER_LOGIN,
  USER_VERIFY_LOGIN,
  USER_FORGOT_PASSWORD,
  USER_SIGN_UP,
  USER_CHANGE_PASSWORD,
  USER_ONBOARD_GET_DATA,
  USER_ONBOARD_STORE_DATA,
  USER_GET_PROFILE,
  USER_STORE_PROFILE,
  USER_STORE_PROFILE_UPDATE,
  USER_BANK_DETAIL,
  USER_BANK_DETAIL_UPDATE,
  USER_BANK_DETAIL_DELETE,
  USER_BANK_DETAIL_ADD,
  USER_FATCA_DETAIL,
  USER_FATCA_DETAIL_UPDATE,
  USER_DOCUMENTS,
  USER_DOCUMENTS_UPDATE,
  USER_NOMINEE_DETAIL,
  USER_NOMINEE_DETAIL_ADD,
  USER_ENACH_REGISTRATION_GET,
  USER_ENACH_REGISTRATION_STORE,
  USER_ENACH_REGISTRATION_CREATE,
  USER_ENACH_REGISTRATION_MAP,
  USER_ENACH_REGISTRATION_DELETE_MANDATE,
  PINCODE,
  BANK_DETAIL,
  ORDER_ID,
  PRODUCT_REF,
  USER_RESENDOTP,
  USER_SEND_OTP,
} from "./types";
import { toast } from "react-toastify";
import axios from "axios";
import { getLocalStorageUserToken } from "../utils/userData";
import axiosInstance from "../api/axios";
import { encryptData } from "../utils/userData";
import { convertDateToDDMMMYYYY } from "../utils/DateFormate";
const token = getLocalStorageUserToken();

// Action to fetch posts

/* done new flow */
export const userLogin = (payload, type) => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}login`,
        payload
      );
      // Assuming the response data is in response.data
      dispatch({ type: USER_LOGIN, payload: response.data });

      if (response?.data?.status !== false) {
        if (type == 1) {
          toast.success("OTP generate successfully!");
        } else {
          toast.success(response?.data?.message);
          if (response?.data?.token) {
            console.log("reponssss", response);
            const encryptedUserData = encryptData(response.data?.data);
            const encryptedUserToken = encryptData(response.data?.token);
            const encryptedUserId = encryptData(response.data?.data?.id);
            localStorage.setItem("userData", encryptedUserData);
            localStorage.setItem("token", encryptedUserToken);
            localStorage.setItem("userId", encryptedUserId);

            if (response?.data?.data?.type == "C") {
              if (response.data?.data?.has_iin_activated == true) {
                setTimeout(() => {
                  window.location.href = "/dashboard";
                }, 400);
              } else {
                if (
                  response.data?.data?.current_wizard_step == 0 ||
                  response.data?.data?.current_wizard_step == null
                ) {
                  setTimeout(() => {
                    window.location.href = "/personal-details";
                  }, 400);
                } else if (response.data?.data?.current_wizard_step == 1) {
                  setTimeout(() => {
                    window.location.href = "/bank-details";
                  }, 400);
                } else if (response.data?.data?.current_wizard_step == 2) {
                  setTimeout(() => {
                    window.location.href = "/fatca-declartion";
                  }, 400);
                } else if (response.data?.data?.current_wizard_step == 3) {
                  setTimeout(() => {
                    window.location.href = "/manage-nominees";
                  }, 400);
                } else if (response.data?.data?.current_wizard_step == 4) {
                  setTimeout(() => {
                    window.location.href = "/dashboard";
                  }, 400);
                } else if (response.data?.data?.current_wizard_step == 5) {
                  setTimeout(() => {
                    window.location.href = "/dashboard";
                  }, 400);
                }
              }
            } else if (response?.data?.data?.type == "R") {
              window.location.href = "/rm/dashboard";
            } else if (response?.data?.data?.type == "A") {
              console.log("dsdsdasdasdasdd");
              window.location.href = "/admin/dashboard";
            }
          }
        }
      } else {
        if (
          response?.data?.message ==
          "Invalid password, couldn\u2019t login. This is attempt number "
        ) {
          toast.error("Invalid password, couldn\u2019t login. ");
        } else {
          toast.error(response?.data?.message);
        }
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      // Handling errors (e.g., network error or server error)
      dispatch({ type: USER_LOGIN, error: error.message });
    }
  };
};

export const userResendOtp = (payload, attempt) => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}resend-otp`,
        payload,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      // Assuming the response data is in response.data
      dispatch({ type: USER_RESENDOTP, payload: response.data });

      if (response?.data?.success !== false) {
        if (parseInt(attempt) === 0) {
          toast.success("OTP sent successfully");
        } else {
          toast.success(response?.data?.message);
        }
      } else {
        toast.error(response?.data?.message);
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      // Handling errors (e.g., network error or server error)
      dispatch({ type: USER_RESENDOTP, error: error.message });
    }
  };
};

export const userVerifyLogin = (payload) => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}login`,
        payload
      );
      // Assuming the response data is in response.data
      dispatch({ type: USER_VERIFY_LOGIN, payload: response.data });
      if (response?.data?.success !== false) {
        if (response?.data?.token) {
          const encryptedUserData = encryptData(response.data?.data);
          const encryptedUserToken = encryptData(response.data?.token);
          const encryptedUserId = encryptData(response.data?.data?.id);
          localStorage.setItem("userData", encryptedUserData);
          localStorage.setItem("token", encryptedUserToken);
          localStorage.setItem("userId", encryptedUserId);

          if (response?.data?.data?.type == "C") {
            if(payload.type != "R"){
toast.success(response?.data?.message);
            }
            if (response.data?.data?.has_iin_activated == true) {
              setTimeout(() => {
                window.location.href = "/dashboard";
              }, 400);
            } else {
              if (
                response.data?.data?.current_wizard_step == 0 ||
                response.data?.data?.current_wizard_step == null
              ) {
                setTimeout(() => {
                  window.location.href = "/personal-details";
                }, 400);
              } else if (response.data?.data?.current_wizard_step == 1) {
                setTimeout(() => {
                  window.location.href = "/bank-details";
                }, 400);
              } else if (response.data?.data?.current_wizard_step == 2) {
                setTimeout(() => {
                  window.location.href = "/fatca-declartion";
                }, 400);
              } else if (response.data?.data?.current_wizard_step == 3) {
                setTimeout(() => {
                  window.location.href = "/manage-nominees";
                }, 400);
              } else if (response.data?.data?.current_wizard_step == 4) {
                setTimeout(() => {
                  window.location.href = "/dashboard";
                }, 400);
              } else if (response.data?.data?.current_wizard_step == 5) {
                setTimeout(() => {
                  window.location.href = "/dashboard";
                }, 400);
              }
            }
          } else if (response?.data?.data?.type == "R") {
            toast.success("RM Login successfully!");
            window.location.href = "/rm/dashboard";
          } else if (response?.data?.data?.type == "A") {
            toast.success("Admin Login successfully!");
            window.location.href = "/admin/dashboard";
          }
        }
      } else {
        // sessionStorage.setItem("attempt", response?.data?.attempt);
        toast.error(response.data.message);
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      // Handling errors (e.g., network error or server error)
      dispatch({ type: USER_VERIFY_LOGIN, error: error.message });
    }
  };
};

export const userSendOtp = (payload, type) => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}send-otp`,
        payload
      );
      // Assuming the response data is in response.data
      dispatch({ type: USER_SEND_OTP, payload: response.data });
      if (response?.data?.success !== false) {
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message);
      }
      return response?.data;
    } catch (error) {
      // Handling error
      // s (e.g., network error or server error)
      toast.error(error?.response?.data?.message);
      dispatch({ type: USER_SEND_OTP, error: error.message });
    }
  };
};

export const userForgotPassword = (payload) => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}forgot-password`,
        payload
      );
      // Assuming the response data is in response.data
      dispatch({ type: USER_FORGOT_PASSWORD, payload: response.data });
      if (response?.data?.success !== false) {
        toast.success(response?.data?.message);
        setTimeout(() => {
          window.location.href = "/login";
        }, 1000);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      toast.error(error?.response?.data?.message);
      dispatch({ type: USER_FORGOT_PASSWORD, error: error.message });
    }
  };
};
export const userVarifyToken = (payload) => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}verify-reset-token`,
        payload
      );
      return response;
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      toast.error(error?.response?.data?.message);
      return error?.response?.data;
    }
  };
};

export const resetPassword = (payload) => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}reset-password`,
        payload
      );
      return response;
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      toast.error(error?.response?.data?.message);
      return error?.response?.data;
    }
  };
};

export const userSignup = (payload) => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}register`,
        payload
      );
      // Assuming the response data is in response.data
      dispatch({ type: USER_SIGN_UP, payload: response.data });
      return response?.data;
    } catch (error) {
      error?.response?.data?.errors?.forEach((msg) => {
        toast.error(msg);
      });
      // Handling errors (e.g., network error or server error)
      dispatch({ type: USER_SIGN_UP, error: error.message });
    }
  };
};

export const userChangePassword = (payload) => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}change-password`,
        payload,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
          },
        }
      );

      // Assuming the response data is in response.data
      dispatch({ type: USER_CHANGE_PASSWORD, payload: response.data });
      if (response?.data?.success !== false) {
        toast.success(response?.data?.message);
        localStorage.removeItem("userData");
        localStorage.removeItem("userId");
        localStorage.removeItem("token");
        setTimeout(() => {
          window.location.href = "/login";
        }, 1000);
      } else {
        toast.error(response.data.message);
      }
      return response?.data;
    } catch (error) {
      console.log("12345", error);
      toast.error(error?.response?.data?.message);
      // Handling errors (e.g., network error or server error)
      dispatch({ type: USER_CHANGE_PASSWORD, error: error.message });
    }
  };
};
/* done new flow */

export const userOnboardingGetDetails = (payload) => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}customer/onboarding/show`,
        payload,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
          },
        }
      );
      if (
        response?.data?.message == "Session expired. Please login again." ||
        response?.data?.message == "Authentication Error!"
      ) {
        localStorage.removeItem("userData");
        localStorage.removeItem("userId");
        localStorage.removeItem("token");
        setTimeout(() => {
          window.location.href = "/login";
        }, 1000);
      }
      // Assuming the response data is in response.data
      dispatch({ type: USER_ONBOARD_GET_DATA, payload: response.data });
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({ type: USER_ONBOARD_GET_DATA, error: error.message });
    }
  };
};

export const userOnboardingStoreData = (
  payload,
  account_no,
  completed_wizard_step
) => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    const payloads = {
      completed_wizard_step: "1",
    };

    let responseOfBank;
    if (completed_wizard_step == 1) {
      responseOfBank = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}customer/onboarding/show`,
        payloads,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
          },
        }
      );
    }

    const bankAccounts = responseOfBank?.data?.data?.bank_account;
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}customer/onboarding/store`,
        payload,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
          },
        }
      );
      if (response.data.data.success == true) {
        if (
          response?.data?.data?.code == 400 &&
          response?.data?.data?.message != "Onboarding data stored"
        ) {
          if (parseInt(payload?.completed_wizard_step) == 0) {
            toast.success("Profile details added successfully");
          } else if (parseInt(completed_wizard_step) == 1) {
            toast.success("Bank details added successfully");
          } else if (parseInt(payload?.completed_wizard_step) == 2) {
            toast.success("FATCA Declaration added successfully");
          } else if (parseInt(completed_wizard_step) == 3) {
            toast.success("Nominee added successfully");
          }
        } else {
          toast.success(response.data.data.message);
        }
      } else {
        if (bankAccounts?.length > 0) {
          const accountExists = bankAccounts?.some(
            (account) => account.acc_no === account_no
          );
          if (accountExists) {
            window.location.href = "/fatca-declartion";
          } else {
            if (response?.data?.data?.errors?.length > 0) {
              toast.error(response?.data?.data?.errors?.[0]);
            } else {
              toast.error(response.data.data.message);
            }
          }
        } else {
          if (response?.data?.data?.errors?.length > 0) {
            toast.error(response?.data?.data?.errors?.[0]);
          } else {
            toast.error(response.data.data.message);
          }
        }
      }
      dispatch({ type: USER_ONBOARD_STORE_DATA, payload: response.data });
      return response.data;
      // Assuming the response data is in response.data
    } catch (error) {
      toast.error(error?.response?.data?.message);
      // Handling errors (e.g., network error or server error)
      dispatch({ type: USER_ONBOARD_STORE_DATA, error: error.message });
    }
  };
};

export const pincode = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}customer/pincode`,
        payload,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
          },
        }
      );
      dispatch({ type: PINCODE, payload: response.data });
      return response.data;
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({ type: PINCODE, error: error.message });
    }
  };
};

export const getBankDetail = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axios.get(`https://ifsc.razorpay.com/${payload}`);
      dispatch({ type: BANK_DETAIL, payload: response.data });
      return response.data;
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({ type: BANK_DETAIL, error: error.message });
    }
  };
};

export const userPofileGet = () => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}profile/getData`,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
          },
        }
      );
      // Assuming the response data is in response.data
      dispatch({ type: USER_GET_PROFILE, payload: response.data });
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({ type: USER_GET_PROFILE, error: error.message });
    }
  };
};

export const userPofileStore = (payload) => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}profile`,
        payload,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
          },
        }
      );
      // Assuming the response data is in response.data
      dispatch({ type: USER_STORE_PROFILE, payload: response.data });
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({ type: USER_STORE_PROFILE, error: error.message });
    }
  };
};

export const userPofileUpdate = (payload) => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}profile/update`,
        payload,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
          },
        }
      );
      dispatch(userPofileGet());
      if (response.data.status == false) {
        toast.error(response.data.message);
      } else {
        toast.success(response.data.message);
      }
      // Assuming the response data is in response.data
      dispatch({ type: USER_STORE_PROFILE_UPDATE, payload: response.data });
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      // Handling errors (e.g., network error or server error)
      dispatch({ type: USER_STORE_PROFILE_UPDATE, error: error.message });
    }
  };
};

export const userBankDetails = () => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}profile/get-bank-accounts`,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
          },
        }
      );
      // Assuming the response data is in response.data
      dispatch({ type: USER_BANK_DETAIL, payload: response.data });
      return response?.data;
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({ type: USER_BANK_DETAIL, error: error.message });
    }
  };
};

export const userBankDetailsUpdate = (payload, id) => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.put(
        `${process.env.REACT_APP_API_URL}bank-accounts/${id}`,
        payload,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
          },
        }
      );
      dispatch(userBankDetails());
      if (response.data.status == false) {
        toast.error(
          response.data.message?.original?.message
            ? response.data.message?.original?.message
            : response.data?.message
        );
      } else {
        toast.success(response.data.message);
      }
      // Assuming the response data is in response.data
      dispatch({ type: USER_BANK_DETAIL_UPDATE, payload: response.data });
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({ type: USER_BANK_DETAIL_UPDATE, error: error.message });
    }
  };
};

export const userBankDetailsDelete = (id) => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.delete(
        `${process.env.REACT_APP_API_URL}profile/delete-bank-accounts/${id}`,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
          },
        }
      );
      dispatch(userBankDetails());
      if (response.data.status == false) {
        toast.error(
          response.data.message?.original?.message
            ? response.data.message?.original?.message
            : response.data?.message
        );
      } else {
        toast.success(response.data.message);
      }
      // Assuming the response data is in response.data
      dispatch({ type: USER_BANK_DETAIL_DELETE, payload: response.data });
    } catch (error) {
      dispatch(userBankDetails());
      toast.error(error?.response?.data?.message);
      // Handling errors (e.g., network error or server error)
      dispatch({ type: USER_BANK_DETAIL_DELETE, error: error.message });
    }
  };
};

export const userBankDetailsAdd = (payload) => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}profile/store-bank-accounts`,
        payload,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
          },
        }
      );
      dispatch(userBankDetails());
      dispatch(userEnachRegitrationGet());
      if (response.data.status == false) {
        if (response?.data?.errors?.length > 0) {
          toast.error(
            response?.data?.errors?.[0]
              ? response?.data?.errors[0]
              : "Something went wrong!"
          );
          return response.data;
        } else {
          toast.error(
            response.data.message?.original?.message
              ? response.data.message?.original?.message
              : response.data?.message
          );
          return response.data;
        }
      } else {
        toast.success(response.data.message);
        return response.data;
      }
      // Assuming the response data is in response.data
      // dispatch({ type: USER_BANK_DETAIL_ADD, payload: response.data });
      // return response.data
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      toast.error(
        error?.response.data.message
          ? error?.response.data.message
          : error?.response.data?.message
      );
      dispatch({ type: USER_BANK_DETAIL_ADD, error: error.message });
    }
  };
};

export const userFatcaDetails = () => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}profile/get-fatca`,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
          },
        }
      );
      // Assuming the response data is in response.data
      dispatch({ type: USER_FATCA_DETAIL, payload: response.data });
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({ type: USER_FATCA_DETAIL, error: error.message });
    }
  };
};

export const userFatcaDetailsUpdate = (payload) => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}profile/store-fatca`,
        payload,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
          },
        }
      );
      dispatch(userFatcaDetails());
      console.log("fdfdfdfdfdfdfdfdfdfd", response.data.status);
      if (response.data.status === false) {
        console.log("fdfdfdfdfdfd1111fdfdfdfd", response.data.status);
        toast.error(
          response.data.message?.original?.message
            ? response.data.message?.original?.message
            : response.data?.message
        );
      } else {
        console.log(
          "fdfdfdfdfdaaaaa",
          response.data?.reg_details,
          response.data?.reg_details?.[0]?.reg_status
        );
        if (response.data?.data?.reg_details?.length > 0) {
          if (response.data?.data?.reg_details[0]?.reg_status == "REG_FAILED") {
            toast.error(response?.data?.data?.reg_details[0]?.reg_remark);
          } else {
            toast.success("Fatca details updated!");
          }
        }
      }
      // Assuming the response data is in response.data
      dispatch({ type: USER_FATCA_DETAIL_UPDATE, payload: response.data });
    } catch (error) {
      console.log("erorrr11111", error);
      // return error?.response?.data
      toast.error(error?.response?.data?.message);
      // Handling errors (e.g., network error or server error)
      dispatch({ type: USER_FATCA_DETAIL_UPDATE, error: error.message });
    }
  };
};

export const userDocumentGet = () => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}profile/get-cheque`,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
          },
        }
      );
      // Assuming the response data is in response.data
      dispatch({ type: USER_DOCUMENTS, payload: response.data });
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({ type: USER_DOCUMENTS, error: error.message });
    }
  };
};

export const userDocumentUpdate = (payload) => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}profile/store-cheque`,
        payload,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
          },
        }
      );
      if (response.data.status == false) {
        toast.error(
          response.data.message?.original?.message
            ? response.data.message?.original?.message
            : response.data?.message
        );
      } else {
        toast.success(response.data.message);
      }
      // Assuming the response data is in response.data
      dispatch({ type: USER_DOCUMENTS_UPDATE, payload: response.data });
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({ type: USER_DOCUMENTS_UPDATE, error: error.message });
    }
  };
};

export const userNomineeDetail = () => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}profile/get-nominees`,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
          },
        }
      );
      // Assuming the response data is in response.data
      dispatch({ type: USER_NOMINEE_DETAIL, payload: response.data });
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({ type: USER_NOMINEE_DETAIL, error: error.message });
    }
  };
};

export const userNomineeDetailAdd = (payload) => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}profile/store-nominees`,
        payload,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
          },
        }
      );
      dispatch(userNomineeDetail());
      if (response.data.status == false) {
        toast.error(response?.data?.message);
      } else {
        toast.success(response?.data?.message);
      }
      // Assuming the response data is in response.data
      dispatch({ type: USER_NOMINEE_DETAIL_ADD, payload: response.data });
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      // Handling errors (e.g., network error or server error)
      dispatch({ type: USER_NOMINEE_DETAIL_ADD, error: error.message });
    }
  };
};

export const userEnachRegitrationGet = () => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}mandates/index`,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
          },
        }
      );
      // Assuming the response data is in response.data
      dispatch({ type: USER_ENACH_REGISTRATION_GET, payload: response.data });
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({ type: USER_ENACH_REGISTRATION_GET, error: error.message });
    }
  };
};

export const userEnachRegitrationStore = (payload) => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}mandates/save`,
        payload,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
          },
        }
      );
      if (response?.data?.status == false) {
        toast.error(response?.data?.message);
      } else {
        toast.success(response?.data?.message);
        dispatch(userEnachRegitrationGet());
        // setTimeout(() => {
        //   window.location.href =
        //     response?.data?.data?.mandate_activation_link?.emandatelink;
        // }, 1000);
      }
      // Assuming the response data is in response.data
      dispatch({ type: USER_ENACH_REGISTRATION_STORE, payload: response.data });
    } catch (error) {
      toast.error(error?.response?.data?.message);
      // Handling errors (e.g., network error or server error)
      dispatch({ type: USER_ENACH_REGISTRATION_STORE, error: error.message });
    }
  };
};

export const userEnachRegitrationCreate = (payload) => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}enach-list/${payload.id}/${payload.type}`,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
          },
        }
      );
      if (response?.data?.status == false) {
        toast.error(response?.data?.message);
      } else {
        toast.success(response?.data?.message);
      }
      // Assuming the response data is in response.data
      dispatch({
        type: USER_ENACH_REGISTRATION_CREATE,
        payload: response.data,
      });
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({ type: USER_ENACH_REGISTRATION_CREATE, error: error.message });
    }
  };
};

export const userEnachRegitrationMap = (payload) => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}enach-map/${payload}`,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
          },
        }
      );
      if (response?.data?.status == false) {
        toast.error(response?.data?.message);
      } else {
        toast.success(response?.data?.message);
      }
      // Assuming the response data is in response.data
      dispatch({
        type: USER_ENACH_REGISTRATION_MAP,
        payload: response.data,
      });
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({ type: USER_ENACH_REGISTRATION_MAP, error: error.message });
    }
  };
};

export const userEnachRegitrationDeleteMandates = (payload) => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}enach-delete`,
        payload,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
          },
        }
      );
      if (response?.data?.status == false) {
        toast.error(response?.data?.message);
      } else {
        dispatch(userEnachRegitrationGet());
        toast.success(response?.data?.message);
      }
      // Assuming the response data is in response.data
      dispatch({
        type: USER_ENACH_REGISTRATION_DELETE_MANDATE,
        payload: response.data,
      });
    } catch (error) {
      // Handling errors (e.g., network error or server error)
      dispatch({
        type: USER_ENACH_REGISTRATION_DELETE_MANDATE,
        error: error.message,
      });
    }
  };
};

export const orderIdData = (payload, userId) => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}cart/orders-details/${payload}?userId=${userId}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({
        type: ORDER_ID,
        payload: response.data,
      });
      return response?.data;
    } catch (error) {
      return error;
    }
  };
};

export const purchaseRefData = (payload) => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}payments-details`,
        payload,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      dispatch({
        type: PRODUCT_REF,
        payload: response.data,
      });
      return response?.data;
    } catch (error) {
      dispatch({
        type: PRODUCT_REF,
        error: error.message,
      });
      return error;
    }
  };
};

export const primaryBankData = (payload) => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}bank-accounts/set-default-account/${payload?.bankId}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      return response?.data;
    } catch (error) {
      return error;
    }
  };
};

export const deleteAccount = (payload) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}delete-account`,
        payload,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
          },
        }
      );
      return response.data;
    } catch (error) {
      toast.error(error.message);
      dispatch({ type: USER_LOGIN, error: error.message });
    }
  };
};

export const mailOtpVerification = (payload) => {
  return async (dispatch) => {
    dispatch({ type: USER_START });
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}delete-account`,
        payload,
        {
          headers: {
            Authorization: `${token}`, // Pass the token here
          },
        }
      );
      dispatch({ type: USER_VERIFY_LOGIN, payload: response.data });
      return response.data;
    } catch (error) {
      dispatch({ type: USER_VERIFY_LOGIN, error: error.message });
    }
  };
};
